import { motion } from "framer-motion";
import { ArrowUpRight, Phone } from "lucide-react";
import { SITE } from "../../lib/site";
import { Marquee } from "./Marquee";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-32 sm:pt-40 pb-16 sm:pb-24 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-end">
          {/* Left */}
          <div className="lg:col-span-7">
            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.05 }}
              className="font-display font-black text-zinc-950 text-5xl sm:text-6xl lg:text-7xl xl:text-8xl tracking-tighter leading-[0.92]"
            >
              Eviniz için,{" "}
              <span className="italic font-medium text-zinc-500">
                size özel yaşam alanları
              </span>{" "}
              tasarlıyor ve yeniliyoruz.
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="mt-8 text-base sm:text-lg text-zinc-600 max-w-2xl leading-relaxed"
            >
              Daire, villa ve müstakil evlerde tadilat, bakım, onarım ve
              yenileme. Keşiften teslimata; konforlu, işlevsel ve sizi
              yansıtan yaşam alanları.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.35 }}
              className="mt-10 flex flex-col sm:flex-row gap-3"
            >
              <a
                href={SITE.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-cta-whatsapp"
                className="group inline-flex items-center justify-between gap-6 px-6 py-4 bg-[#00844A] text-white hover:bg-[#006F3E] transition-all duration-300"
              >
                <span className="font-bold text-sm tracking-wide">
                  WhatsApp’tan Hızlı Fiyat Sor
                </span>
                <ArrowUpRight
                  size={18}
                  className="group-hover:rotate-45 transition-transform duration-300"
                />
              </a>
              <a
                href={`tel:${SITE.phoneTel}`}
                data-testid="hero-cta-call"
                className="group inline-flex items-center justify-between gap-6 px-6 py-4 border border-zinc-950 text-zinc-950 hover:bg-zinc-950 hover:text-white transition-all duration-300"
              >
                <span className="font-bold text-sm tracking-wide">
                  Hemen Ara · {SITE.phoneDisplay}
                </span>
                <Phone size={16} />
              </a>
            </motion.div>
          </div>

          {/* Right - image card */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-5"
          >
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-zinc-100">
              <img
                src="/assets/ana-sayfa-hero-donusum.webp"
                alt="Bir tarafı tamamlanmış, diğer tarafı tadilat aşamasındaki modern yaşam alanı"
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/40 via-transparent to-transparent" />
              <div className="absolute bottom-1 sm:bottom-2 left-0 right-0 flex justify-center px-5">
                <img
                  src="/assets/artibir-logo.png"
                  alt="Artı Bir Yapı"
                  className="h-10 sm:h-12 w-auto max-w-[290px] object-contain"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Marquee */}
      <div className="mt-20 sm:mt-28 border-y border-zinc-200 bg-zinc-50">
        <Marquee
          testId="hero-words-marquee"
          ariaLabel="Hizmet anahtar kelimeleri"
          speed={1.6}
          innerClassName="py-5"
          items={[
            "Kaba İşler",
            "Sıva Boya",
            "Zemin Kaplama",
            "Otomatik Sistemler",
            "Alçıpan Sistemleri",
            "Mutfak Yenileme",
            "Mekanik Tesisat",
            "Elektrik & Aydınlatma",
            "Su Yalıtımı",
            "Isı Yalıtımı",
            "Ses Yalıtımı",
            "Banyo Yenileme",
          ]}
          renderItem={(w) => (
            <span className="font-display font-bold text-2xl sm:text-3xl text-zinc-900 tracking-tight flex items-center gap-12 px-6">
              {w}
              <span className="w-1.5 h-1.5 bg-[#00844A]" />
            </span>
          )}
        />
      </div>
    </section>
  );
};
